<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>{{ $t('v4.PAYMENT INFO') }}</h4>
            </div>
        </div>
        <div
            class="card-body"
        >
            <b-form>
                <b-form-group :label="$t('v4.Product Information')" style="width:100%;">
                    <b-form-input type="text" :value="productInfo.fake" disabled></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('v4.Payment Amount')" style="width:100%;">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                {{ currencyIsUsd ? '$' : '￦' }}
                            </span>
                        </div>
                        <b-form-input style="text-align:right;" type="text" :value="amount" disabled></b-form-input>
                    </div>
                </b-form-group>
                <b-form-group :label="$t('v4.Payer Name')" style="width:100%;">
                    <b-form-input type="text" :value="buyerName" disabled></b-form-input>
                </b-form-group>
                <b-form-group :label="$t('v4.Email')" style="width:100%;">
                    <b-form-input type="text" name="allat_email_addr" :value="email"></b-form-input>
                </b-form-group>
            </b-form>
                <!-- <iframe style="left:0px; top:0px; width:0px; height:0px; position:absolute; z-index:1000; display:block; background-color:white;" id="hiddenFrame" name="hiddenFrame" frameborder="0"></iframe> -->
            <form id="KGPAY" ref="KGPAY">
                <input type="hidden" name="allat_amt" :value="costKrw">
                <input type="hidden" name="allat_buyer_nm" :value="buyerName">
                <input type="hidden" name="allat_fix_email_addr" :value="email">
                <input type="hidden" name="allat_email_addr" :value="email">
                <input type="hidden" name="allat_encode_type" value="U">
                <input type="hidden" name="allat_shop_id" :value="shiopId">
                <input type="hidden" name="allat_order_no" :value="'a' + orderNumber">
                <input type="hidden" name="allat_product_cd" value="AWS">
                <input type="hidden" name="allat_pmember_id" :value="email.substring(0, 20)">
                <input type="hidden" name="allat_product_nm" :value="productInfo.value" class="form-control">
                <input type="hidden" name="allat_recp_nm" value="이주완">
                <input type="hidden" name="allat_recp_addr" value="메가존클라우드">
                <input type="hidden" name="shop_receive_url" :value="receiveUrl">
                <input type="hidden" name="allat_enc_data">
                <input type="hidden" name="allat_test_yn" :value="ALLAT_TEST_YN">
                <input type="hidden" name="allat_company_nm" :value="COMPANY_TITLE">
            </form>
            <div style="display:flex;justify-content:space-between">
                <b-button variant="danger" @click="cancelPay">
                    {{ $t('v4.Cancel') }}
                </b-button>
                <b-button variant="success" @click="startKgPay">
                    {{ $t('v4.Pay') }}
                </b-button>
            </div>
        </div>
    </b-card>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent'
export default {
    props: {
        data: {
            type: Object,
            default: function () {
                return {}
            }
        },
        user: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data () {
        return {
            ALLAT_TEST_YN: 'N',
            PATH: '/kg/assignment/payment',
            SERVER: process.env.VUE_APP_COMMON_URL,
            NAMESPACE: process.env.VUE_APP_NAMESPACE,
            SERVICE_GROUP: process.env.VUE_APP_SERVICE,
            COMPANY_TITLE: process.env.VUE_APP_CARDPAY_COMPANY_TITLE,
            BASIC_SHOP_ID: process.env.VUE_APP_CARDPAY_BASIC_SHOP_ID,
            USD_SHOP_ID: process.env.VUE_APP_CARDPAY_USD_SHOP_ID
        }
    },
    computed: {
        amount () {
            return this.currencyIsUsd ? this.costKrw / 100 : this.costKrw
        },
        shiopId () {
            return this.currencyIsUsd ? this.USD_SHOP_ID : this.BASIC_SHOP_ID
        },
        receiveUrl () {
            return `${this.SERVER}${this.PATH}/${this.NAMESPACE}/${this.SERVICE_GROUP}/${this.shiopId}/${this.costKrw}`
        },
        productInfo () {
            const monthArray = this.data.latestMonth.slice().split('-')
            const year = monthArray[0]
            const month = monthArray[1]
            return {
                fake: `AWS ${year}년 ${month}월`,
                value: `AWS ${this.data.latestMonth}`
            }
        },
        currency () {
            return this.data.currency
        },
        costKrw () {
            return this.data.costKrw
        },
        currencyIsUsd () {
            return this.currency === 'usd'
            // return true
        },
        buyerName () {
            return this.user.userName.substring(0, 10)
        },
        email () {
            return this.user.email
        },
        orderNumber () {
            const orderIdx = this.data.assignedIdxs.map(value => value)
            return orderIdx.join(',')
        }
    },
    mounted () {
        if (this.currencyIsUsd) {
            this.$_allatPayEN()
        } else {
            this.$_allatPay()
        }
        window.result_submit = this.resultSubmit
    },
    methods: {
        startKgPay () {
            window.AllatPay_Approval(this.$refs['KGPAY'])
            window.AllatPay_Closechk_Start()
        },
        resultSubmit (resultCd, resultMsg, encData) {
            window.AllatPay_Closechk_End()
            if (resultCd !== '0000') {
                window.setTimeout(() => {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                            title: `${resultCd}`,
                            icon: 'CoffeeIcon',
                            variant: 'warning',
                            text: `${resultMsg}`
                        }
                    })
                }, 1000)
            } else {
                window.fm.allat_enc_data.value = encData
                window.fm.action = 'allat_approval.php'
                window.fm.method = 'post'
                window.fm.target = '_self'
                window.fm.submit()
            }
        },
        cancelPay () {
            this.$emit('back:page')
        }
    }
}
</script>

<style>

</style>
